import { Configuration, DefaultApi, ResponseError } from './api/generated'

export { ResponseError } from './api/generated'
export type {
  AnswerRequest,
  AnswerResponse,
  CitationResponse,
  ConversationCitationResponse,
  ConversationMessageResponse,
  ConversationResponse,
  CurrentUserResponse,
  DailyFeedbackResponse,
  DailyUsageBucketResponse,
  FeedbackRequest,
  SystemPromptResponse,
  SourceUsageResponse,
  UsageAnalyticsResponse,
  UserDaySliceResponse,
  UserRoleResponse,
} from './api/generated'

export class ApiError extends Error {
  readonly status: number
  readonly code: string | null
  constructor(message: string, status: number, code: string | null = null) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
  }
}

export type AnswerServiceOptions = {
  baseUrl: string
  acquireToken: () => Promise<string>
  fetchImpl?: typeof fetch
}

export function createAnswerService(options: AnswerServiceOptions): DefaultApi {
  const config = new Configuration({
    basePath: options.baseUrl.replace(/\/$/, ''),
    accessToken: options.acquireToken,
    fetchApi: options.fetchImpl ?? fetch,
  })
  return new DefaultApi(config)
}

export async function toApiError(err: unknown): Promise<ApiError> {
  if (err instanceof ResponseError) {
    const detail = await err.response.text().catch(() => '')
    return new ApiError(detail || err.response.statusText, err.response.status)
  }
  if (err instanceof Error) return new ApiError(err.message, 0)
  return new ApiError('Unknown error', 0)
}
